<template>
  <!-- start footer -->
  <footer id="divFooter">
    <div class="container">
      <div class="row">
        <div class="col-md-8 col-sm-12">
          <p>Copyright &copy; 2019 <a rel="nofollow" href="https://www.epapersign.com" target="_blank">ePaper LTD</a></p>
        </div>
        <div class="col-md-4 col-sm-12">
          <small>Developed by <a rel="nofollow" href="https://www.epapersign.com" target="_blank">ePaper LTD</a></small>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>
<script>
  export default {
    name: 'footerT',
    data () {
      return {
      }
    },
    computed: {
    },
    created () {
    },
    methods: {
    }
  }
</script>
<style>
  #divFooter{
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// footer.vue?054a1421